import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { Role } from 'src/app/shared/role';

@Component({
  selector: 'curr-student-profile-subject-table',
  templateUrl: './student-profile-subject-table.component.html',
  styleUrls: ['./student-profile-subject-table.component.scss',
    '../../../shared/components/user-statistic-table/user-statistic-table.component.scss']
})
export class StudentProfileSubjectTableComponent implements OnInit, OnChanges {

  @Input() tableData = [];
  @Input() userRole!: string;
  @Input() currentProfileData!: any;
  @Output() onSetPredictedGrade = new EventEmitter<{grade: string, course_id: string}>();

  userRoles = Role;
  studentId;

  tableFields = [
    { fieldName: 'subject', fieldFilter: 'all' },
    { fieldName: 'predicted_grade', fieldFilter: 'all' },
    { fieldName: 'avg_grade', fieldFilter: 'all' },
    { fieldName: 'performance', fieldFilter: 'all' }

  ];
  displayedColumns = ['subject', 'predicted_grade', 'avg_grade', 'performance'];
  STUDENTS_DATA = [];
  dataSource: any;
  isPredictedGradeMenuOpen = false;
  clickedPendingUser = '';
  ddOptionsPredictedGrade = [];
  ddGcseOptionsPredictedGrade = [];
  isAdminAsTeacher = false;

  @ViewChild(MatSort, { static: false }) set content(sort: MatSort) {
    // @ts-ignore
    this.dataSource?.sort = sort;
  }

  constructor(private route: ActivatedRoute) {
    this.ddOptionsPredictedGrade = [
      { value: 'A*', label: 'A*' },
      { value: 'A', label: 'A' },
      { value: 'B', label: 'B' },
      { value: 'C', label: 'C' },
      { value: 'D', label: 'D' },
      { value: 'E', label: 'E' },
      { value: 'U (NP)', label: 'U (NP)' },
      { value: 'U (BS)', label: 'U (BS)' },
      { value: 'U (Fail)', label: 'U (Fail)' }
    ];

    this.ddGcseOptionsPredictedGrade = [
      { value: '9', label: '9' },
      { value: '8', label: '8' },
      { value: '7', label: '7' },
      { value: '6', label: '6' },
      { value: '5', label: '5' },
      { value: '4', label: '4' },
      { value: '3', label: '3' },
      { value: '2', label: '2' },
      { value: '1', label: '1' }
    ];
  }

  predictedGradeOptions(useGcse: boolean) {
    return useGcse
      ? this.ddGcseOptionsPredictedGrade
      : this.ddOptionsPredictedGrade;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initTableData();
  }

  ngOnInit(): void {
    if (this.currentProfileData.user_type === 'SCHOOL_ADMIN' && !this.currentProfileData.multipleSchoolsAccess) {
      this.isAdminAsTeacher = this.currentProfileData.permissions.beTeacher;
    }

    this.route.params.pipe(take(1))
      .subscribe(res => {
        this.studentId = res?.studentId;
      });
    this.initTableData();
  }

  initTableData() {
    if (this.tableData.length) {
      this.STUDENTS_DATA = [];

      this.STUDENTS_DATA.push(...this.tableData);
      this.STUDENTS_DATA.forEach(i => {
        i.sa_completion_rate = i.sa_completion_rate > 1 ? i.sa_completion_rate / 100 || 0 : i.sa_completion_rate;
        // i.performance = i.performance > 1 ? i.performance / 100 || 0 : i.performance;
      });
      this.dataSource = new MatTableDataSource(this.STUDENTS_DATA);
    }
  }

  clickPredictedGrade($event: MouseEvent, elem: any) {
    this.clickedPendingUser = elem.subject;
    $event.stopPropagation();
    this.isPredictedGradeMenuOpen = true;
  }

  closePredictedGradeMenu() {
    this.isPredictedGradeMenuOpen = false;
  }

  setPredictedGrade(grade: string, el: any) {
    this.onSetPredictedGrade.emit({grade, course_id: el.courseId});
  }
}
